import React from 'react';
import { IIconProps } from './utils';

export const Audio = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M23.5692 5.37495C23.0859 4.88196 22.2945 4.8741 21.8015 5.35738C21.3085 5.84066 21.3006 6.63207 21.7839 7.12506C23.7745 9.15555 24.9998 11.9334 24.9998 15C24.9998 18.0666 23.7745 20.8444 21.7839 22.8749C21.3006 23.3679 21.3085 24.1593 21.8015 24.6426C22.2945 25.1259 23.0859 25.118 23.5692 24.6251C25.9993 22.1462 27.4998 18.7471 27.4998 15C27.4998 11.2529 25.9993 7.85382 23.5692 5.37495Z" fill={fill} />
    <path d="M21.041 10.1611C20.6588 9.58618 19.8829 9.42996 19.308 9.81216C18.7331 10.1944 18.5768 10.9702 18.959 11.5451C19.6166 12.5343 19.9998 13.7205 19.9998 15C19.9998 16.2795 19.6166 17.4657 18.959 18.4549C18.5768 19.0298 18.7331 19.8056 19.308 20.1878C19.8829 20.57 20.6588 20.4138 21.041 19.8389C21.9627 18.4524 22.4998 16.787 22.4998 15C22.4998 13.213 21.9627 11.5476 21.041 10.1611Z" fill={fill} />
    <path d="M2.5 13.6868V16.3132C2.5 17.7637 3.74365 18.9396 5.27778 18.9396H6.51676C7.52367 18.9396 8.51165 19.1983 9.37507 19.6881L12.8965 21.6858C13.8223 22.211 15 21.5805 15 20.5598V9.44022C15 8.41948 13.8223 7.789 12.8965 8.31417L9.37507 10.3119C8.51165 10.8017 7.52367 11.0604 6.51676 11.0604H5.27778C3.74365 11.0604 2.5 12.2363 2.5 13.6868Z" fill={fill} />
  </svg>
);
